module.exports = __webpack_public_path__ + "img/icon-bitcoin.05eb9af8.svg";